import type { SettlementKeywordDefinition, SettlementPreviewMeta } from '@/models/settlementTypes';

export const SETTLEMENT_V1_KEYWORDS: SettlementKeywordDefinition[] = [
  {
    token: '{matter_name}',
    sampleValue: 'Geller v. Acme Logistics',
    group: 'Matter',
  },
  {
    token: '{gross_recovery}',
    sampleValue: '$150,000.00',
    group: 'Amounts',
  },
  {
    token: '{attorney_fee}',
    sampleValue: '$50,000.00',
    group: 'Amounts',
  },
  {
    token: '{total_expenses}',
    sampleValue: '$4,250.00',
    group: 'Amounts',
  },
  {
    token: '{total_liens}',
    sampleValue: '$12,500.00',
    group: 'Amounts',
  },
  {
    token: '{net_to_client}',
    sampleValue: '$83,250.00',
    group: 'Amounts',
  },
  {
    token: '{attorney_name}',
    sampleValue: 'Blanche Allen',
    group: 'Parties',
  },
  {
    token: '{client_name}',
    sampleValue: 'Monica Geller',
    group: 'Parties',
  },
];

export const SETTLEMENT_PREVIEW_SAMPLE_VALUES: Record<string, string> =
  SETTLEMENT_V1_KEYWORDS.reduce((accumulator, keyword) => {
    accumulator[keyword.token.slice(1, -1)] = keyword.sampleValue;
    return accumulator;
  }, {} as Record<string, string>);

export const SETTLEMENT_PREVIEW_META: SettlementPreviewMeta = {
  statementDate: 'May 12, 2026',
  rows: [
    { label: 'Gross recovery', valueKey: 'gross_recovery' },
    { label: 'Attorney fee', valueKey: 'attorney_fee' },
    { label: 'Total expenses', valueKey: 'total_expenses' },
    { label: 'Total liens', valueKey: 'total_liens' },
    { label: 'Net to client', valueKey: 'net_to_client', bold: true },
  ],
};
